import React from 'react';
import {SafeAreaView} from 'react-native';
import {SuccessPopup} from '.';
import {tID} from '../../utils/TestIdHelper';
import makeStyles from './styles';
import {useThemedStyles} from '../../theme';

const UI = ({children, openPopup, showSuccesModal, onPressFinish}) => {
  const styles = useThemedStyles(makeStyles);
  return (
    <>
      {openPopup && !showSuccesModal ? (
        <SafeAreaView
          testID={tID('ChangePhoneNumberVerification-SafeAreaView-OverlayContainer')}
          style={styles.overlayContainer}>
          {children}
        </SafeAreaView>
      ) : null}
      <SuccessPopup
        showSuccesModal={showSuccesModal}
        onPressFinish={onPressFinish}
      />
    </>
  );
};

export default UI;
